<template>
  <div class="h-app overflow-hidden flex flex-col justify-stretch">
    <div class="flex-grow overflow-hidden flex flex-col justify-stretch">
      <Specification height="h-full w-full" @close="close" />
    </div>
    <div class="h-14 flex-none"></div>
  </div>
</template>

<script>
import Specification from "@/components/product/Specification.vue";
export default {
  components: {
    Specification,
  },
  auth: false,
  async asyncData({store, $axios, params, redirect}) {
    try {
      const {data} = await $axios.get("/api/products/" + params.product);
      const item = data.data;
      store.dispatch("specification/setItem", item);

      return {
        item,
      };
    } catch (e) {
      redirect("/404");
    }
  },
  head() {
    const {name, description, image, no} = this.item;
    const title = `${process.env.APP_NAME}-${name}`;

    return {
      title: title,
      meta: [
        {hid: "description", name: "description", content: description},
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: title,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: title,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/order/product/${no}`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: description,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: image ?? `${process.env.APP_URL}/imgs/logo.png`,
        },
      ],
    };
  },
  methods: {
    close() {
      // check history can go back
      this.$router.push(this.localePath({name: "order"}));
    },
  },
};
</script>
